class FeaturedCollections extends HTMLElement {
  constructor() {
    super();
    this.collectionBtns = this.querySelectorAll('.collection-btn');
    this.viewAllBtns = this.querySelectorAll('.view-all');
    this.collectionContents = this.querySelectorAll('.collection-content');
    this.arrows = this.querySelectorAll('.featured-collections__body > .icon-arrow');
    this.collectionBtnBackground = this.querySelector('.collection-btn__background');

    this.collectionBtns.forEach(btn => {
      btn.addEventListener('click', this.updateOuterSlider.bind(this));
    })
    this.createInnerSliders();
    this.arrows.forEach(arrow => {
      arrow.addEventListener('click', this.onArrowClick.bind(this));
    })
    document.addEventListener('DOMContentLoaded', this.updateCollectionBtnBackground.bind(this));
    window.addEventListener('resize', this.updateCollectionBtnBackground.bind(this));
    window.addEventListener('load', this.disabledArrows.bind(this));
    window.addEventListener('resize', this.disabledArrows.bind(this));
  }

  updateOuterSlider(e) {
    const target = e.target;
    if (target.classList.contains('active')) return;
    const targetIndex = target.dataset.index;
    const currentCollectionURL = target.dataset.url;

    // 1. collectionBtn 'active' class
    this.collectionBtns.forEach(el => {
      if (el.dataset.index === targetIndex) el.classList.add('active');
      else el.classList.remove('active');
    });

    // 2. Update collectionBtnBackground
    this.collectionBtnBackground.classList.add('animate');
    this.updateCollectionBtnBackground();

    // 3. Show related collection
    this.collectionContents.forEach((collection) => {
      // Collection content 'active' class
      collection.classList.remove('active');
      if (collection.dataset.index === targetIndex) collection.classList.add('active');

      // Animation
      collection.style.transform = `translateX(calc(${targetIndex * -100}% - ${targetIndex * 24}px))`}
    );

    // 4. Update View All link
    this.viewAllBtns.forEach(btn => btn.setAttribute('href', currentCollectionURL));

    // 5. disabled arrows
    setTimeout(() => {
      this.disabledArrows();
    }, 300);
  }

  createInnerSliders() {
    var drag = false;
    this.querySelectorAll('.featured-collections-slider').forEach(slider => { 
      new KeenSlider(slider, {
        dragChecked() {
          drag = true;
        },
        dragEnded() {
          setTimeout(() => (drag = false), 0);
        },
        created() {
          document.querySelectorAll('.featured-collections-slider').forEach(slider => {
            slider.addEventListener("click", (e) => {
              if (drag) {
                e.stopPropagation();
                e.preventDefault();
              }
            })
          });
        },
        slides: {
          perView: 4,
          spacing: 24
        },
        breakpoints: {
          '(max-width: 749px)': {
            slides: {
              perView: 2,
              spacing: 16
            }
          },
          '(min-width: 750px)': {
            slides: {
              perView: 3,
              spacing: 24
            }
          },
          '(min-width: 990px)': {
            slides: {
              perView: 4,
              spacing: 24
            }
          },
        },
      }, [navigation])
    })
  }

  onArrowClick(e) {
    const currentArrow = e.target.closest('.icon-arrow');
    const activeCollection = this.querySelector('.collection-content.active');
    const activeCollectionLeftArrow = activeCollection.querySelector('.arrow--left');
    const activeCollectionRightArrow = activeCollection.querySelector('.arrow--right');

    if (currentArrow.classList.contains('arrow--left')) activeCollectionLeftArrow.click();
    else if (currentArrow.classList.contains('arrow--right')) activeCollectionRightArrow.click();

    setTimeout(() => {
      this.disabledArrows();
    }, 300);
  }

  updateCollectionBtnBackground() {
    this.collectionBtns.forEach(btn => {
      if (btn.classList.contains('active')) {
        this.collectionBtnBackground.style.width = `${parseInt(getComputedStyle(btn).width)}px`;
        this.collectionBtnBackground.style.left = `${btn.offsetLeft}px`;
      }
    })
  }

  disabledArrows() {
    const leftArrow = this.querySelector('.featured-collections__body > .icon-arrow.arrow--left');
    const rightArrow = this.querySelector('.featured-collections__body > .icon-arrow.arrow--right');
    const activeCollection = this.querySelector('.collection-content.active');
    const activeCollectionLeftArrow = activeCollection.querySelector('.arrow--left');
    const activeCollectionRightArrow = activeCollection.querySelector('.arrow--right');

    if (activeCollectionLeftArrow.classList.contains('arrow--disabled')) leftArrow.classList.add('arrow--disabled');
    else leftArrow.classList.remove('arrow--disabled');

    if (activeCollectionRightArrow.classList.contains('arrow--disabled')) rightArrow.classList.add('arrow--disabled');
    else rightArrow.classList.remove('arrow--disabled');
  }
}

customElements.define('featured-collections', FeaturedCollections);